import parse from "html-react-parser";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import nl2br from "nl2br";
import Constant from '../../apis/constants';

export function sharableUrl(path) {
    return encodeURI(Constant.host + path);
}

export function stringLimit(string, limit) {
    return string !== null
        ? string.length >= limit
            ? string.substr(0, limit) + "..."
            : string
        : "";
}

export function toHtml(string) {
    return parse(string);
}

export function stripTags(html) {
    return html.replace(new RegExp('&nbsp;', 'g'), '').replace(/(<([^>]+)>)/gi, "");
}

export function uuId() {
    return uuidv4();
}

export function _date(timestamp) {
    let date = new Date(timestamp);
    let d = date.getDate();
    d = d < 10 ? "0" + d : d;

    let m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;

    let y = date.getFullYear();

    return d + "/" + m + "/" + y;
}

export function _time(date) {
    return moment(date).format("LT");
}

export function _msdate(timestamp) {
    let date = new Date(timestamp);
    let d = date.getDate();
    d = d < 10 ? "0" + d : d;

    let m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;

    let y = date.getFullYear();

    return y + "-" + m + "-" + d;
}

export function dateText(timestamp) {
    var d = new Date(timestamp);
    var days = ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"];
    var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
    ];

    return (
        days[d.getDay()] +
        ", " +
        d.getDate() +
        " " +
        months[d.getMonth()] +
        (new Date().getFullYear() !== d.getFullYear()
            ? ` ` + d.getFullYear()
            : ``)
    );
}

export function timeAgo(time) {
    let today = moment().format("L");
    let expected = moment(time).format("L");
    if (today === expected) {
        return moment(time).utcOffset("+0000").fromNow(true);
    } else {
        return moment(time).utcOffset("+0000").format("LT");
    }
}

export function enterToBR(string) {
    return nl2br(string);
}

export function getMonths(name = false) {
    // let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return name ? months[name] : months
}

export function getYear() {
    let date = new Date();
    return date.getFullYear();
}

export function range(start, end, mZero = false) {
    var ans = [];
    for (let i = start; i <= end; i++) {
        if (mZero) {
            ans.push(i <= 9 ? '0' + i : i);
        }
        else {
            ans.push(i);
        }
    }
    return ans;
}

export function leapYear(year)
{
  return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
}

export function charLimit(string, limit = null)
{
    return limit !== null ? ( string.length > limit ? string.substr(0, limit) : string ) + '...': string;
}
